import WorkersComponent from "../components/Workers/WorkersComponent";

export default function WorkersPage() {
  return (
    <>
      <WorkersComponent />
    </>
  );
}
